<template>
  <div class=" mt-2">
    <b-breadcrumb class="breadcrumb-pipes">
      <b-breadcrumb-item href="/settings/admin-panel/">
          Admin Panel
        </b-breadcrumb-item>
        <b-breadcrumb-item href="/settings/user-role">
          Roles and Permissions
        </b-breadcrumb-item>
        <b-breadcrumb-item href="/settings/personal-settings">
          Personal Settings
        </b-breadcrumb-item>
      </b-breadcrumb>
    <b-card class="mb-0" :title="$t('settings.currency.titles.manage_currencies')">
      <b-overlay :show="loading" rounded="sm" no-fade>
        <div class="m-2">
          <b-row align-h="between">
            <b-col cols="12" md="3">
              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1"
                :placeholder="$t('general_text.search_table')"
              />
            </b-col>
            <b-col v-if="$Can('add_currency')" cols="12" md="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-button variant="success" @click="addCurrencyModal">
                  <span class="text-nowrap">{{$t('settings.currency.buttons.create_new_currency')}}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          striped
          hover
          ref="refUserListTable"
          class="position-relative p-2"
          :items="allCurrencies"
          :filter="filter"
          filter-debounce="250"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          selectable
          select-mode="single"
          responsive
          :small="true"
          head-variant="dark"
          :fields="tableColumns"
          show-empty
          :empty-text="$t('general_messages.no_matching_recors_found')"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template #cell(index)="data">
            <b
              ><span class="font-weight-bold">
                <strong class="text-primary">#{{ data.index + 1 }}</strong>
              </span></b
            >
          </template>
          <!-- Column: Currency -->
          <template #cell(Currency)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Currency ? data.item.Currency : "N/A"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="deleteCurrency(data.item)">
                <feather-icon icon="DeleteIcon" />
                <span class="align-middle ml-50">{{ $t('settings.currency.buttons.delete_currency') }} </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            <span class="text-muted"
                >{{$t('general_text.showing')}} {{ dataMeta.from }} {{$t('general_text.to')}} {{ dataMeta.to }} {{$t('general_text.of')}}
                {{ dataMeta.of }} {{$t('general_text.entries')}}</span
              >
            </b-col>

            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
      {{ /*currency create modal*/ }}
      <b-modal
        id="modal-prevent-closing"
        v-model="currencyCreateModal"
        :title="$t('settings.currency.titles.create_new_currency')"
        @hidden="resetCurrencyCreateModal"
        size="md"
        ok-title=""
        :ok-title="$t('settings.currency.buttons.create')"
        :cancel-title="$t('settings.currency.buttons.cancel')"
        @ok="createCurrency"
      >
        <b-overlay :show="createCurrencyloading" rounded="sm" no-fade>
          <b-container>
            <b-form>
              <b-row class="mt-2">
                <b-col cols="12" xl="12" md="12">
                  <validation-observer ref="createCurrencyValidation">
                    <b-form>
                      <!-- currency name -->
                      <b-form-group>
                        <validation-provider
                          #default="{ errors }"
                          :name="$t('settings.currency.titles.currency_name')"
                          rules="required|min:3"
                        >
                          <b-form-input
                            id="currencyname"
                            v-model="newCurrency"
                            name="currency-name"
                            :state="errors.length > 0 ? false : null"
                            :placeholder="$t('settings.currency.titles.currency_name')"
                            autofocus
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-form>
                  </validation-observer>
                </b-col>
              </b-row>
            </b-form>
          </b-container>
          <template #overlay v-if="createCurrencyloading">
            <div
              class="text-center d-flex justify-content-center align-items-start"
            >
              <b-icon icon="stopwatch" font-scale="3" animation="cylon">
              </b-icon>
              <p id="cancel-label">
                <feather-icon icon="DownloadIcon" /> {{ $t('settings.currency.messages.currency_creating_message') }} 
              </p>
            </div>
          </template>
        </b-overlay>
        {{/****END*** currency create modal*/}}
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormRating,
  VBModal,
  BTabs,
  BTab,
  BCardText,
  BIcon,
} from "bootstrap-vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../../settingsStoreModule";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, min, max } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "axios";
import axiosIns from "@/libs/axios";
import router from "@/router";
import moment from "moment";
import "animate.css";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BTabs,
    BTab,
    BCardText,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    BIcon,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    BBreadcrumb, BBreadcrumbItem
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
    const SETTINGS_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
      store.registerModule(SETTINGS_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
        store.unregisterModule(SETTINGS_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      allCurrencies: [],
      currencyCreateModal: false,
      allCreatedCurrencies: [],
      accessLevel: null,
      filterModal: null,
      updatePermloading: false,
      createCurrencyloading: false,
      newCurrency: null,

      filterOn: ["Currency"],
      tableColumns: [
        {
          key: "index",
          label: "",
        },
        {
          key: "Currency",
          label: this.$t('settings.currency.table.currency_name'),
          sortable: true,
        },
        { key: "actions", label:this.$t('settings.currency.table.actions'), sortable: false },
      ],
      perPage: localStorage.getItem("currencyShow") ?? 10,
      currentPage: 1,
      totalRows: 0,
      perPageOptions: [10, 25, 50, 100],
      filter: null,

      loading: false,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters["authUser"];
      },
      set(newValue) {
        return this.$store.dispatch("setUser", newValue);
      },
    },
    ...mapGetters(["authUser"]),
    dataMeta() {
      return {
        from:
          this.totalRows != 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
  },
  mounted() {
    this.getCurrencies();
  },
  methods: {
    getCurrencies() {
      this.loading = true;
      store
        .dispatch("settings/fetchCurrencies", this.user)
        .then((res) => {
          this.allCurrencies = res.data;
          this.totalRows = res.data.length;
          this.loading = false;
        })
        .catch((error) => {
          this.databaseErrorMessage();
          console.log(error);
        });
    },
    addCurrencyModal() {
      this.currencyCreateModal = true;
    },
    createCurrency(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.createCurrencyValidation.validate().then((success) => {
        if (success) {
          this.createCurrencyloading = true;
          store
            .dispatch("settings/checkExistingCurrency", {
              user: this.user,
              currency: this.newCurrency.toUpperCase(),
            })
            .then((res) => {
              if (res.data.existing == 1) {
                this.existingCurrencyMessage();
                this.createCurrencyloading = false;
              } else {
                 
                  store
                    .dispatch("settings/createNewCurrency", {
                      user: this.user,
                      currency: this.newCurrency.toUpperCase()
                    })
                    .then((res) => {
                      this.createCurrencyloading = false;
                      this.resetCurrencyCreateModal();
                      this.getCurrencies();
                      this.createCurrencyToastMessage();
                    })
                    .catch((error) => {
                      console.log(error);
                    });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    resetCurrencyCreateModal() {
      this.currencyCreateModal = false;
      this.allCreatedCurrencies = [];
      this.newCurrency = null
      this.createCurrencyloading = false;
    },
    deleteCurrency(currency) {
      const self = this;

      this.$swal({
        title: this.$t('settings.currency.titles.are_you_sure_delete') + ` ${currency.Currency}`,
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t('settings.currency.buttons.yes_delete_it'),
        cancelButtonText: this.$t('settings.currency.buttons.cancel'),
        customClass: {
          confirmButton: "btn btn-success mr-1",
          cancelButton: "btn btn-danger",
          denyButton: "btn btn-primary",
        },
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          self.loading = true;
          store
            .dispatch("settings/deleteCurrency", {
              user: this.user,
              currency: currency.Currency,
            })
            .then((res) => {
              if (res.data.info == true) {
                self.getCurrencies();
                self.loading = false;
                self.$swal.fire({
                  icon: "success",
                  title: self.$t('settings.currency.titles.deleted'),
                  text:  self.$t('settings.currency.messages.currency_has_been_delete'),
                  showClass: {
                    popup: "animate__animated animate__fadeInDown",
                  },
                });
              }else {
                this.currencyNotFoundMessage();
                self.loading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    databaseErrorMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t('settings.currency.messages.database_error'),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    existingCurrencyMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t('settings.currency.messages.currency_is_exist'),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    currencyNotFoundMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t('settings.currency.messages.currency_not_found'),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    createCurrencyToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Successfully",
          text: this.$t('settings.currency.messages.currency_create_success'),
          icon: "ThumbsUpIcon",
          variant: "success",
        },
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  watch: {
    perPage: {
      handler: function(val, before) {
        localStorage.setItem("userShow", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
